<template>
  <ul>
    <li v-for="(error, index) in errors" :key="index">
      <Reusable_Alert :color="color" :message="error" @close="removeError(index)" />
    </li>
  </ul>
</template>

<script>

import Reusable_Alert from '@/components/widgetcomponents/Reusable_Alert.vue'

export default {
  components: {Reusable_Alert},
  props: {
    received_errors: { // eslint-disable-line vue/prop-name-casing
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: '#FF968A'
    }
  },
  data() {
    return {
      errors:this.received_errors
    }
  },
  watch: {
    received_errors(newErrors) {
      this.errors = newErrors;
    }
  },
  methods:{
    removeError(index) {
      this.errors.splice(index, 1)
    }
  },
}
</script>
